import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	exportIssuesFlagExportComplete: {
		id: 'issue-navigator-action-export-issues.export-item.export-issues-task-flag.export-issues-flag-export-complete',
		defaultMessage: 'Export complete',
		description: 'Title of export issues flag when export is completed',
	},
});

export default messages;
